import { render, staticRenderFns } from "./KnowledgeBaseCategoryPublicationCreate.vue?vue&type=template&id=ad22b862&"
import script from "./KnowledgeBaseCategoryPublicationCreate.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCategoryPublicationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports